"use client";

import { useEffect } from "react";

export const CleverTapInit = () => {
	useEffect(() => {
		if (typeof window === "undefined" || window.clevertap) return;
		if (process.env.NEXT_PUBLIC_CLEVERTAP_ENABLED !== "true") return;

		try {
			// Initialize CleverTap
			window.clevertap = {
				event: [],
				profile: [],
				account: [],
				onUserLogin: [],
				notifications: [],
			};

			// Add your CleverTap Account ID
			window.clevertap.account.push({
				id: process.env.NEXT_PUBLIC_CLEVERTAP_ACCOUNT_ID,
			});

			// Load CleverTap SDK
			const script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.src = "https://d2r1yp2w7bby2u.cloudfront.net/js/clevertap.min.js";
			script.onload = () => {
				window.clevertap?.setLogLevel?.(3);
				window.dispatchEvent(new Event("clevertap_ready"));
			};
			script.onerror = () => {
				console.error("Failed to load CleverTap SDK");
			};
			document.head.appendChild(script);
		} catch (error) {
			console.error("CleverTap initialization error:", error);
		}
	}, []);

	return null;
};
